export enum BuilderStateEnum {
  IS_CREATING = 'isCreating',
  IS_UPDATING = 'isUpdating',
  IS_DELETING = 'isDeleting',
  IS_GETTING = 'isGetting',
  ERROR = 'error',
  NODE_LIST = 'nodeList',
  EDGE_LIST = 'edgeList'
}
